export var InputTypeType;
(function (InputTypeType) {
    InputTypeType["BUTTON"] = "button";
    InputTypeType["CHECKBOX"] = "checkbox";
    InputTypeType["COLOR"] = "color";
    InputTypeType["DATE"] = "date";
    InputTypeType["DATETIME_LOCAL"] = "datetime-local";
    InputTypeType["EMAIL"] = "email";
    InputTypeType["FILE"] = "file";
    InputTypeType["HIDDEN"] = "hidden";
    InputTypeType["IMAGE"] = "image";
    InputTypeType["MONTH"] = "month";
    InputTypeType["NUMBER"] = "number";
    InputTypeType["PASSWORD"] = "password";
    InputTypeType["RADIO"] = "radio";
    InputTypeType["RANGE"] = "range";
    InputTypeType["RESET"] = "reset";
    InputTypeType["SEARCH"] = "search";
    InputTypeType["SUBMIT"] = "submit";
    InputTypeType["TEL"] = "tel";
    InputTypeType["TEXT"] = "text";
    InputTypeType["TIME"] = "time";
    InputTypeType["URL"] = "url";
    InputTypeType["WEEK"] = "week";
})(InputTypeType || (InputTypeType = {}));
//# sourceMappingURL=inputType.js.map